<template>
  <div class="brand-slider-group">
    <div class="owl-carousel testimonial-brand-slider owl-theme">
      <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
        <Slide v-for="record in Company" :key="record.id">
          <div class="brand-logos">
            <img
              :src="require(`@/assets/img/${record.Image}`)"
              class="img-fluid"
              alt="Brand-logo"
            />
          </div>
        </Slide>
        <template #addons> </template>
      </Carousel>
    </div>
  </div>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Company from "@/assets/json/company.json";
export default {
  data() {
    return {
      Company: Company,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
